import React from 'react';
import { Reveal } from './Reveal';
const steps = [{
  number: '01',
  title: 'Aprende',
  text: 'Conoce la industria y desarrolla nuevas habilidades.'
}, {
  number: '02',
  title: 'Desarróllate',
  text: 'Recibe capacitación y acompañamiento durante tu proceso.'
}, {
  number: '03',
  title: 'Crece',
  text: 'Avanza de acuerdo con tus objetivos, compromiso y resultados.'
}];
export function Opportunity() {
  return <section id="oportunidad" className="w-full scroll-mt-16 bg-ivory py-24 sm:py-32 lg:py-40" aria-labelledby="opportunity-title" data-id="element-197" data-mp="2gznz1voreoi4">
      <div className="mx-auto max-w-page px-5 sm:px-10 lg:px-12" data-id="element-198" data-mp="2qsmsprz4558l">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[1fr_1fr] lg:gap-24" data-id="element-199" data-mp="2vqev5fxdw9r1">
          <Reveal data-id="element-200" data-mp="2vshkryumk0v8">
            <h2 id="opportunity-title" className="font-sans text-[1.85rem] font-light uppercase leading-[1.12] text-ink sm:text-[2.5rem] xl:text-[3rem]" data-id="element-201" data-mp="2zsjhrupf0646">
              Conoce una nueva
              <br data-id="element-202" data-mp="yejm7vlyzj8g" />
              posibilidad en la
              <br data-id="element-203" data-mp="ubwsfp5qno8m" />
              industria de servicios
              <br data-id="element-204" data-mp="ub3r53pjtqxv" />
              financieros.
            </h2>
          </Reveal>

          <Reveal delay={0.08} data-id="element-205" data-mp="pdv9r5c85qxo">
            <div className="max-w-xl space-y-6 font-sans text-[17px] font-light leading-relaxed text-steel sm:text-lg" data-id="element-206" data-mp="pd2asqjic5q3">
              <p data-id="element-207" data-mp="kg25wiye990k">
                Conoce una industria enfocada en ayudar a personas y familias a
                comprender mejor diferentes herramientas y soluciones
                financieras.
              </p>
              <p className="text-ink" data-id="element-208" data-mp="18belwhtzbpob">
                Recibirás capacitación y acompañamiento durante el proceso,
                incluso si nunca has trabajado en este sector.
              </p>
            </div>
            <p className="mt-8 max-w-md font-sans text-sm font-light leading-relaxed text-steel-400" data-id="element-209" data-mp="20sh9pzva17nu">
              Algunas actividades requieren completar la capacitación y obtener
              las licencias correspondientes.
            </p>
          </Reveal>
        </div>

        <div className="mt-20 grid grid-cols-1 border-t border-ink/12 sm:mt-24 md:grid-cols-3" data-id="element-210" data-mp="3uaoj3yit84mp">
          {steps.map((step, i) => <Reveal key={step.number} delay={i * 0.08} className={`border-b border-ink/12 md:border-b-0 md:border-r md:last:border-r-0 ${i > 0 ? 'md:pl-10' : ''} ${i < steps.length - 1 ? 'md:pr-10' : ''}`} data-id="element-211" data-mp="3gi8cyoum3qhk" data-mpi={i}>
              <div className="py-9 md:py-11" data-id="element-212" data-mp="3bkgjvri8dybs">
                <span className="block font-serif text-4xl text-champagne sm:text-5xl" data-id="element-213" data-mp="3bi3w2xpsktqt">
                  {step.number}
                </span>
                <h3 className="mt-6 font-sans text-sm font-medium uppercase tracking-[0.2em] text-ink" data-id="element-214" data-mp="32j0drvyg8idd">
                  {step.title}
                </h3>
                <p className="mt-3 max-w-xs font-sans text-base font-light leading-relaxed text-steel" data-id="element-215" data-mp="vqzh2j0fhpm1">
                  {step.text}
                </p>
              </div>
            </Reveal>)}
        </div>

        <Reveal delay={0.1} data-id="element-216" data-mp="15wzfxaqy7vvb">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/121cf1c9-d8c2-4233-b486-cbb1f2793244.jpg" alt="Grupo de profesionales conversando en una sala de reuniones luminosa" className="mt-16 h-[300px] w-full object-cover sm:mt-20 sm:h-[440px]" data-id="element-217" data-mp="15xsehofr7f2d" />
        </Reveal>
      </div>
    </section>;
}